// extracted by mini-css-extract-plugin
export var primitiveLabel = "_ug-0";